@let isLoading =
  assistantGroup.workspace.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();
@let addMenuOpen = addMenuOpenSg();

<aside class="conversation-selector">
  <!-- Header -->
  <div class="conversation-selector__header">
    <h3 class="conversation-selector__title">
      <span>Workspaces</span>
    </h3>
    <i
      class="atn-icon atn-plus atn-blue"
      #btnOrigin
      (click)="addMenuOpenSg.set(true)"
    ></i>
  </div>

  <!-- Content -->
  <div class="conversation-selector__content">
    @if (isLoading) {
      <div class="conversation-selector__loading">
        <atn-ds-loader type="typing" />
      </div>
    } @else {
      <atn-workspace-tree />
    }
  </div>
</aside>

<!-- Represent the add menu -->
@if (addMenuOpen) {
  <atn-ds-attached-overlay
    [origin]="btnOrigin"
    (backdropClick)="addMenuOpenSg.set(false)"
  >
    <div class="conversation-selector__menu">
      <button
        class="conversation-selector__menu-item"
        type="button"
        (click)="createConversation()"
      >
        <i class="atn-icon atn-comment atn-blue"></i>
        <span>New Conversation</span>
      </button>
      <button
        class="conversation-selector__menu-item"
        type="button"
        (click)="createWorkspace()"
      >
        <i class="atn-icon atn-folder atn-yellow"></i>
        <span>New Workspace</span>
      </button>
    </div>
  </atn-ds-attached-overlay>
}
